import React from "react";
import { ArrowRight } from "lucide-react";
import { HERO, IMAGES, SCARCITY } from "../mock";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-ls grain pt-28 md:pt-36 pb-16 md:pb-24"
    >
      {/* ambient glow */}
      <div
        className="pointer-events-none absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full opacity-20"
        style={{ background: "radial-gradient(circle, #f26a21, transparent 70%)" }}
      />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left copy */}
          <div>
            <div className="inline-flex items-center gap-2 border border-[rgba(242,106,33,0.4)] rounded-[4px] px-3 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-sm" style={{ backgroundColor: "var(--ls-orange)" }} />
              <span className="ls-eyebrow">{HERO.eyebrow}</span>
            </div>

            <h1 className="font-display text-white text-[15vw] sm:text-[64px] md:text-[76px] lg:text-[82px]">
              {HERO.titleLines.map((line, i) => (
                <span key={i} className="block">
                  {line}
                </span>
              ))}
              <span className="block text-orange">{HERO.titleHighlight}</span>
            </h1>

            <p className="mt-6 text-lg md:text-xl text-[#c7bdae] max-w-md leading-relaxed">
              {HERO.subtitle}
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a href="#cta" className="btn-orange text-base">
                Get More Jobs <ArrowRight className="w-4 h-4" />
              </a>
              <a href="#how" className="btn-ghost text-base">
                See How It Works
              </a>
            </div>

            <p className="mt-6 text-sm text-[#9a8f80] font-cond tracking-wide">
              Website built for <span className="text-orange font-bold">free</span>. $597/mo. Cancel anytime.
            </p>
            <p className="mt-1 text-sm text-white font-cond font-bold tracking-wide">{HERO.value}</p>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full px-3.5 py-1.5" style={{ background: "rgba(242,106,33,0.12)", border: "1px solid rgba(242,106,33,0.35)" }}>
              <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: "var(--ls-orange)" }} />
              <span className="text-xs font-cond font-bold uppercase tracking-wide text-[#f2b98f]">{SCARCITY}</span>
            </div>
          </div>

          {/* Right image */}
          <div className="relative">
            <div className="hero-frame rounded-lg overflow-hidden bg-black">
              <img
                src={IMAGES.heroContractor}
                alt="LightSpeed ROI — we build the engine, you build the legacy"
                className="w-full aspect-square object-cover"
              />
            </div>
            {/* Orange quote box */}
            <div
              className="absolute -bottom-6 -left-4 md:left-6 max-w-xs p-5 shadow-2xl"
              style={{ backgroundColor: "var(--ls-orange)", borderRadius: "6px" }}
            >
              <p className="font-cond font-bold text-[#1a0f06] text-xl leading-tight">
                &ldquo;{HERO.quote}&rdquo;
              </p>
              <p className="mt-2 text-xs font-bold tracking-[0.2em] uppercase text-[#5c3410]">
                — {HERO.quoteAuthor}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
